module.exports = ".container\n{\n  padding: 10px;\n}\n\n\n.message\n{\n  height: 200px;\n}\n"